export default function(str) {
  return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase();
}
